import * as yup from 'yup';

function firstName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'FIRST_NAME_IS_REQUIRED',
      defaultMessage: 'First Name is required',
    }),
  );
}

function lastName(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'LAST_NAME_IS_REQUIRED',
      defaultMessage: 'Last Name is required',
    }),
  );
}

function enabled(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

function role(formatMessage) {
  return yup.object().required(
    formatMessage({
      id: 'ROLE_IS_REQUIRED',
      defaultMessage: 'Role is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      firstName: firstName(formatMessage),
      lastName: lastName(formatMessage),
      enabled: enabled(formatMessage),
      role: role(formatMessage),
    })
    .required();

export default validationSchema;
